import {IntermediatePart} from "../../intermediatePart";

export default class BackgroundBG extends IntermediatePart {
  constructor(isChild) {
    super(isChild);
    this.partId = 'background_bg';
    this.partName = 'Background BG';
  }

  load(dbFeature) {
    return super.load_(dbFeature, new BackgroundBG());
  }
}
